<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else >
            <template v-slot:header>
                <h5>Detail Merk Barang</h5>
            </template>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA MERK</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Merk Barang</b-col>
                    <b-col>{{ merkBarang.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jenis Barang</b-col>
                    <b-col>{{ merkBarang.barangJenis.name }}</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">SPESIFIKASI</h6>
                <b-table bordered hover show-empty :fields="spesifikasiFields" :busy="isBusy" :items="merkBarang.spesifikasi" responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data spesifikasi.
                    </template>
                    <template v-slot:cell(nominalAngka)="row">
                        <div class="text-right no wrap" v-if="row.item.nominalAngka == null">{{$helper.addThousandSeparator(row.item.nominalAngka)}} </div>
                        <div class="text-right no wrap text-danger" v-else-if="row.item.nominalAngka < 0">Rp. {{$helper.addThousandSeparator(row.item.nominalAngka)}} </div>
                        <div class="text-right no wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalAngka)}} </div>
                    </template>
                    <template v-slot:cell(nominalPersen)="row">
                        <div class="text-right no-wrap" v-if="row.item.nominalPersen == null">{{$helper.addThousandSeparator(row.item.nominalPersen)}} </div>
                        <div class="text-right no-wrap text-danger" v-else-if="row.item.nominalPersen < 100 ">{{$helper.addThousandSeparator(row.item.nominalPersen)}} %</div>
                        <div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(row.item.nominalPersen)}} %</div>
                    </template>
                    <template v-slot:cell(isActive)="row">
                        <span v-if="(row.item.isActive == true)" class="badge badge-success">aktif</span>
                        <span v-else class="badge badge-danger">non aktif</span>
                    </template>
                </b-table>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">KONDISI</h6>
                <b-table bordered hover show-empty :fields="fields" :busy="isBusy" :items="merkBarang.kondisi" responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data kondisi.
                    </template>
                    <template v-slot:cell(klasifikasi)="row">
                        <div v-if="row.item.dus !== null">
                            <span v-if="row.item.dus">Dus</span>
                            <span v-else>Non Dus</span>
                        </div>
                        <div v-else>
                            <span v-if="row.item.namaSendiri">Sendiri</span>
                            <span v-else>Orang Lain</span>
                        </div>
                    </template>
                    <template v-slot:cell(hargaMaksimal)="row">
                        <div class="text-right no wrap" v-if="row.item.hargaMaksimal == null">{{$helper.addThousandSeparator(row.item.hargaMaksimal)}} </div>
                        <div class="text-right no wrap text-danger" v-else-if="row.item.hargaMaksimal < 0">Rp. {{$helper.addThousandSeparator(row.item.hargaMaksimal)}} </div>
                        <div class="text-right no wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.hargaMaksimal)}} </div>
                    </template>
                    <template v-slot:cell(nominalAngka)="row">
                        <div class="text-right no wrap" v-if="row.item.nominalAngka == null">{{$helper.addThousandSeparator(row.item.nominalAngka)}} </div>
                        <div class="text-right no wrap text-danger" v-else-if="row.item.nominalAngka < 0">Rp. {{$helper.addThousandSeparator(row.item.nominalAngka)}} </div>
                        <div class="text-right no wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalAngka)}} </div>
                    </template>
                    <template v-slot:cell(nominalPersen)="row">
                        <div class="text-right no-wrap" v-if="row.item.nominalPersen == null">{{$helper.addThousandSeparator(row.item.nominalPersen)}} </div>
                        <div class="text-right no-wrap text-danger" v-else-if="row.item.nominalPersen < 100 ">{{$helper.addThousandSeparator(row.item.nominalPersen)}} %</div>
                        <div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(row.item.nominalPersen)}} %</div>
                    </template>
                    <template v-slot:cell(isActive)="row">
                        <span v-if="(row.item.isActive == true)" class="badge badge-success">aktif</span>
                        <span v-else class="badge badge-danger">non aktif</span>
                    </template>
                </b-table>
            </div>

           
            <div class="d-flex">
                <div class="detail-edit-btn mr-2">
                    <b-button variant="pgiBtn" name="merkBarangEditBtn" @click="editMerkBarang">Edit</b-button>
                </div>
                <div class="detail-edit-btn mr-2">
                    <b-button variant="pgiBtn" name="ubahHarga" @click="editKondisi">Ubah Kondisi</b-button>
                </div>
            </div>

            <b-modal id="modal-edit-kondisi" size="xl" title="Edit Kondisi Merk Barang" no-close-on-esc no-close-on-backdrop>
         
                <b-form id="updateKondisiForm">
                    <MKondisi :rincian="merkBarang" />
                </b-form>

                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button variant="secondary" name="closeEditHargaBtn" @click="cancel()">
                        Cancel
                    </b-button>
                </template>
            </b-modal>
            
            <ModalConfirm id="modal-confirm-hapus-kondisi" title="Confirm Hapus Kondisi"  desc="Apakah anda yakin untuk menghapus kondisi barang ini?" @submit="onSubmitHapusKondisi" />
            <ModalConfirm id="modal-confirm-non-aktif-kondisi" title="Confirm Non Aktif Kondisi"  desc="Apakah anda yakin untuk menonaktifkan kondisi barang ini?" @submit="onSubmitNonAktifKondisi" />
            <ModalConfirm id="modal-confirm-aktif-kondisi" title="Confirm Aktif Kondisi"  desc="Apakah anda yakin untuk mengaktifkan kondisi barang ini?" @submit="onSubmitAktifKondisi" />

        </b-card>
    </div>
</template>

<script>
import Kondisi from '../../../components/kondisi/Kondisi'
import KondisiNonAktif from '../../../components/kondisi/KondisiNonAktif'
import MKondisi from './MKondisi.vue'

export default {
    name: 'detail-merk-barang',
    components: { 
        Kondisi, KondisiNonAktif, MKondisi
    },
    data(){
        return{
            id: null,
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            input:{
                merkBarang: "",
                jenisBarang: null,
                spesifikasi: [],
                kondisi: [],
                filePDF: null,
                filePDFKondisi: null,
            },
            isKendaraan: false,
            indexKondisi: 0,
            nonAktifKondisiMerk:[],
            deleteKondisi: [],
            modalConfirmRemove: {},
            modalConfirmNonAktif: {},
            modalConfirmAktif: {},

            fields: [
                { key: "name", label: "Grade Barang", sortable:true},
                { key: "klasifikasi", label: "Klasifikasi", sortable:true},
                { key: "hargaMaksimal", label: "Harga Maksimal", sortable: true},
                { key: "nominalAngka", label: "Nominal Angka", sortable: true},
                { key: "nominalPersen", label: "Nominal Persen", sortable: true},
                { key: "keterangan", label: "Keterangan", sortable: true},
                { key: "isActive", label: "Status", sortable: true}
            ],
            spesifikasiFields:[
                { key: "name", label: "Spesifikasi Barang", sortable:true},
                { key: "nominalAngka", label: "Nominal Angka", sortable: true},
                { key: "nominalPersen", label: "Nominal Persen", sortable: true},
                { key: "isActive", label: "Status", sortable: true}
            ],
            merkBarang: {
                barangJenis: []
            },
            jenisBarang:[],
            textNominal: '',
            nominalPersen: '',
            textDus: ''
        }
    }, 
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getJenis = this.$axios.get("barang-jenis/").then(response => {
                this.jenisBarang = response.data
            })
            let getSingleMerkBarang = this.$axios.get(`barang-merk/${this.id}`).then(response => {
                this.merkBarang = response.data
                this.toggleBusy()

                for (var x of this.merkBarang.kondisi) {
                    if (x.nominalAngka != null) {
                        this.textNominal = "Nominal dalam Angka"
                    } 
                    else { 
                        this.textNominal = "Nominal dalam Persen"
                        this.nominalPersen = x.nominalPersen + '%'
                    }
                    if (x.dus != null) {
                        if (x.dus == true) {
                            this.textDus = "Packing: Dus"
                        }
                        else this.textDus = "Packing: Non-dus"
                    } 
                    else {
                        if (x.namaSendiri == true) {
                            this.textDus = "BPKB: Atas Nama Sendiri"
                        }
                        else this.textDus = "BPKB: Atas Nama Orang Lain"
                    }
                }
                
               //----------------- Inisialisasi Data Merk Barang -----------------

               this.input.merkBarang = this.merkBarang.name
               this.input.jenisBarang = this.merkBarang.barangJenis.id

               let nameMerk, ketMerk, namaSendiriMerk, dusMerk, detailInfoMerk, hargaMaksimalMerk= null

               for (var x of this.merkBarang.kondisi) {
                   nameMerk = x.name
                   ketMerk = x.keterangan
                   hargaMaksimalMerk = this.$helper.addThousandSeparator(x.hargaMaksimal)
                   let nominalPMerk, nominalAMerk, nominalAngka = null
                   

                   if (x.dus == null) {
                       if(x.namaSendiri == true) namaSendiriMerk = 0
                       else namaSendiriMerk = 1
                   } 
                   else {
                       if(x.dus == true) dusMerk = 0
                       else dusMerk = 1
                   }

                   if (x.nominalAngka == null) {
                       detailInfoMerk = "persen",
                       nominalPMerk = x.nominalPersen                            
                   } 
                   else {
                       nominalAngka = this.$helper.addThousandSeparator(x.nominalAngka);
                       detailInfoMerk = "nominal",
                       nominalAMerk = nominalAngka
                   }

                   if (dusMerk == null) dusMerk = 0
                   if (namaSendiriMerk == null) namaSendiriMerk = 0

                   if(x.isActive == true){

                       this.input.kondisi.push({
                           index: this.indexKondisi,
                           id: x.id,
                           name: nameMerk,
                           keterangan: ketMerk,
                           dus: dusMerk,
                           namaSendiri: namaSendiriMerk,
                           detailInfo: detailInfoMerk,
                           nominalPersen: nominalPMerk,
                           nominalAngka: nominalAMerk,
                           hargaMaksimal: hargaMaksimalMerk,
                           filePDF: [],
                       })
                   }else if(x.isActive == false){
                       this.nonAktifKondisiMerk.push({
                           index: this.indexKondisi,
                           id: x.id,
                           name: nameMerk,
                           keterangan: ketMerk,
                           dus: dusMerk,
                           namaSendiri: namaSendiriMerk,
                           detailInfo: detailInfoMerk,
                           nominalPersen: nominalPMerk,
                           nominalAngka: nominalAMerk,
                           hargaMaksimal: hargaMaksimalMerk
                       })
                   }
                   
                   this.indexKondisi++
               }    

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getJenis,getSingleMerkBarang]).then(() => {
                let jenis = this.jenisBarang.filter(item => item.id == this.id)
        
                if (jenis.length != 0) {            
                    let namaJenis = jenis[0].jenisPinjaman.name
                    if (namaJenis == 'Kendaraan') {
                        this.isKendaraan = true
                    } 
                    else if (namaJenis == 'Elektronik') {
                        this.isKendaraan = false
                    }
                }
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        addKondisi() {
            this.input.kondisi.unshift({ 
                index: this.indexKondisi, 
                id: 0, 
                name: "", 
                dus: 0,
                namaSendiri: 0,
                keterangan: "",
                detailInfo: "persen",
                nominalPersen: null,
                nominalAngka: null,
                hargaMaksimal: 0,
                filePDF: [],
                url : []
            })
            this.indexKondisi++;
        },

        removeKondisi(index, id) {
            this.$bvModal.show("modal-confirm-hapus-kondisi")
            this.modalConfirmRemove = {
                index: index,
                id: id
            }
            // this.input.kondisi = this.input.kondisi.filter(item => item.index != index)
            // this.deleteKondisi.push(id)
        },

        nonAktifKondisi(item) {
            this.$bvModal.show("modal-confirm-non-aktif-kondisi")
            this.modalConfirmNonAktif = item
        },

        editKondisi(){
            this.$bvModal.show('modal-edit-kondisi')
        },

        onSubmitHapusKondisi() {
            this.$bvModal.hide("modal-confirm-hapus-kondisi")
            this.input.kondisi  = this.input.kondisi.filter(item => item.index != this.modalConfirmRemove.index)
            if(this.modalConfirmRemove.id != 0){
                this.deleteKondisi.push(this.modalConfirmRemove.id)
            }
            // this.deleteKondisi.push(this.modalConfirmRemove.id)
        },

        onSubmitNonAktifKondisi() {
            let payloadNonAktif = new FormData()
            payloadNonAktif.append("id", this.modalConfirmNonAktif.id)
            payloadNonAktif.append("isActive", false)
            this.$axios.post("/barang-merk/kondisi/switch-is-active", payloadNonAktif).then(() => {
                location.reload()
                // this.$helper.setFlash(`Merk barang telah berhasil di nonaktifkan!`)
                // let path = this.$route.path.split("/")
                // path.pop()
                // path = path.join("/")
                // this.$router.push({ path })
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            // this.input.kondisi = this.input.kondisi.filter(item => item.index != this.modalConfirmNonAktif.index)
            // this.nonAktifKondisiMerk.push(this.modalConfirmNonAktif)

            this.$bvModal.hide("modal-confirm-non-aktif-kondisi")
        },

        onSubmitAktifKondisi() {
            let payloadAktif = new FormData()
            payloadAktif.append("id", this.modalConfirmAktif.id)
            payloadAktif.append("isActive", true)
                this.$axios.post("/barang-merk/kondisi/switch-is-active", payloadAktif).then(() => {
                    location.reload() 
                    // this.$helper.setFlash(`Merk barang telah berhasil di aktifkan!`)
                    // let path = this.$route.path.split("/")
                    // path.pop()
                    // path = path.join("/")
                    // this.$router.push({ path })
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
            // this.nonAktifKondisiMerk = this.nonAktifKondisiMerk.filter(item => item.index != this.modalConfirmAktif.index)
            // this.input.kondisi.push(this.modalConfirmAktif)
            this.$bvModal.hide("modal-confirm-aktif-kondisi")
        },

        aktifKondisi(item) {
            this.$bvModal.show("modal-confirm-aktif-kondisi")
            this.modalConfirmAktif = item
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        editMerkBarang(){
            this.$router.push({path: `${this.$route.path}/edit`});
        }

    },
    
    created(){
        this.init()
    }
}
</script>
